import React from 'react';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

export default function Screen3() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen3-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '[data-scroll-root="aixue-phonics"]',
    enableResizeDetection: true,
    scrollTriggerCallback: () => {
      const rootEl = rootRef.current;
      if (!rootEl) return;

      const targets = rootEl.querySelectorAll<HTMLElement>('[data-sp3-anim]');
      targets.forEach((el) => {
        const delay = el.dataset.sp3Delay || '0s';
        const duration = el.dataset.sp3Duration || '0.8s';
        const cls = 'animate__fadeInUp';
        el.classList.add('animate__animated');
        el.classList.remove('animate__fadeInUp', 'animate__fadeIn');
        void el.offsetWidth;
        el.classList.add(cls);
        el.style.animationDelay = delay;
        el.style.animationDuration = duration;
      });
    }
  });

  return (
    <section className={styles['screen3-cover']} ref={rootRef}>
      <div className={styles['screen3-wrap']}>
        {/* 标题 */}
        <div className={styles['screen3-title']}>AI自然拼读</div>

        {/* 三栏等级卡片 */}
        <div className={styles['screen3-flex']}>
          {/* 初级 */}
          <div
            className={`${styles['screen3-card']} ${styles['screen3-card1']}`}
            data-sp3-anim="up"
            data-sp3-delay="0s"
            data-sp3-duration="0.8s"
          >
            <div className={`${styles['screen3-card-head']} ${styles['screen3-head-level1']}`}>
              <div className={styles['screen3-head-title']}>初级</div>
              <div className={styles['screen3-head-sub']}>LEVEL 1</div>
            </div>

            <div className={`${styles['screen3-card-body1']} ${styles['screen3-card1-body1']}`}>
              <ul className={styles['screen3-list']}>
                <li>建立26个字母的音形对应，发现字母不同结构的发音规律。</li>
                <li>拼读CVC和CVCE单词，体会见词读、听音写的成就感。</li>
                <li>
                  <p className={styles['screen3-li-blue']}>
                    解决“不敢读、不会读”的
                    <span className={styles['screen3-font-blue']}>单词认读</span>难题。
                  </p>
                </li>
              </ul>
            </div>

            <div className={`${styles['screen3-card-body2']} ${styles['screen3-card1-body2']}`}>
              <ul className={styles['screen3-list']}>
                <li>
                  <span className={styles['screen3-font-blue']}>40</span>节课
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>26</span>个字母+
                  <span className={styles['screen3-font-blue']}>5</span>组长短元音
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>168</span>个核心词
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>7</span>本绘本
                </li>
              </ul>
            </div>
          </div>

          {/* 中级 */}
          <div
            className={`${styles['screen3-card']} ${styles['screen3-card2']}`}
            data-sp3-anim="up"
            data-sp3-delay="0.1s"
            data-sp3-duration="1s"
          >
            <div className={`${styles['screen3-card-head']} ${styles['screen3-head-level2']}`}>
              <div className={styles['screen3-head-title']}>中级</div>
              <div className={styles['screen3-head-sub']}>LEVEL 2</div>
            </div>

            <div className={`${styles['screen3-card-body1']} ${styles['screen3-card2-body1']}`}>
              <ul className={styles['screen3-list']}>
                <li>探索字母组合的发音规律。</li>
                <li>拼读CCVC，CWC，CVCCE词，感受词汇量提升带来的成就感。</li>
                <li>
                  <p className={styles['screen3-li-blue']}>
                    摆脱“死记硬背”的<span className={styles['screen3-font-blue']}>单词背诵</span>
                    痛苦。
                  </p>
                </li>
              </ul>
            </div>

            <div className={`${styles['screen3-card-body2']} ${styles['screen3-card2-body2']}`}>
              <ul className={styles['screen3-list']}>
                <li>
                  <span className={styles['screen3-font-blue']}>40</span>节课
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>58</span>个字母组合
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>168</span>个核心词
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>7</span>本绘本
                </li>
              </ul>
            </div>
          </div>

          {/* 高级 */}
          <div
            className={`${styles['screen3-card']} ${styles['screen3-card3']}`}
            data-sp3-anim="up"
            data-sp3-delay="0.2s"
            data-sp3-duration="1.2s"
          >
            <div className={`${styles['screen3-card-head']} ${styles['screen3-head-level3']}`}>
              <div className={styles['screen3-head-title']}>高级</div>
              <div className={styles['screen3-head-sub']}>LEVEL 3</div>
            </div>

            <div className={`${styles['screen3-card-body1']} ${styles['screen3-card3-body1']}`}>
              <ul className={styles['screen3-list']}>
                <li>探索更多字母组合的发音规律。</li>
                <li>拆分多音节单词、认读合成词、押韵词，培养拼读优势，增加自我效能感。</li>
                <li>
                  <p className={styles['screen3-li-blue']}>
                    化解“长难词、复杂词”的
                    <span className={styles['screen3-font-blue']}>单词记忆</span>困境。
                  </p>
                </li>
              </ul>
            </div>

            <div className={`${styles['screen3-card-body2']} ${styles['screen3-card3-body2']}`}>
              <ul className={styles['screen3-list']}>
                <li>
                  <span className={styles['screen3-font-blue']}>40</span>节课
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>48</span>个字母组合
                </li>
                <li>多音节、合成词、押韵词</li>
                <li>
                  <span className={styles['screen3-font-blue']}>168</span>个核心词
                </li>
                <li>
                  <span className={styles['screen3-font-blue']}>7</span>本绘本
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
